<div class="td-wb-chip-list__item-container"
     aria-live="polite">
  <ng-content />
</div>
